// // src/components/ServicesSectionTwo.jsx
// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css"; // make sure package is installed

// export default function ServicesSectionTwo() {
//   const bgStyle = { backgroundImage: "url('/images/background/1.jpg')" };

//   const services = [
//     {
//       icon: "/images/page-img/Parking.png",
//       title: "Parking",
//       text:
//         "Adequate parking facilities have been thoughtfully provided to ensure the utmost convenience for our residents, addressing their parking needs seamlessly.",
//       href: "/services-single.html",
//     },
//     {
//       icon: "/images/page-img/Free-Wifi.png",
//       title: "Free Wifi",
//       text:
//         "In this fast-paced digital age, connectivity is key, and Shree Swami Samarth PG is committed to providing residents with a seamless online experience through free WiFi services.",
//       href: "/services-single.html",
//     },
//     {
//       icon: "/images/page-img/Refrigerator.png",
//       title: "Refrigerator",
//       text:
//         "Each room is thoughtfully equipped with a refrigerator, adding a touch of convenience to residents' stays by providing a handy space for storing and preserving their essentials.",
//       href: "/services-single.html",
//     },
//      {
//       icon: "/images/page-img/Almirah.png",
//       title: "Almirah",
//       text:
//         "In every room, residents benefit from the availability of spacious almirahs, ensuring organized and efficient storage solutions to enhance their living experience.",
//       href: "/services-single.html",
//     },
//     {
//       icon: "/images/page-img/Washroom.png",
//       title: "Washroom",
//       text:
//         "Residents benefit from conveniently accessible and well-maintained washrooms, reflecting our commitment to ensuring their comfort and satisfaction with the overall living.",
//       href: "/services-single.html",
//     },
//     {
//       icon: "/images/page-img/CCTV-Camera.png",
//       title: "CCTV Camera",
//       text:
//         "Prioritizing the safety of our residents, key areas are equipped with CCTV cameras, underscoring our commitment to maintaining a secure and protected living environment.",
//       href: "/services-single.html",
//     },
//   ];

//   return (
//     <section className="services-section-two" style={bgStyle}>
//       <div className="section-inner">
//         <div className="auto-container">
//           {/* Sec Title */}
//           <div className="sec-title light centered">
//             <h2>Our Services</h2>
//             <div className="sub-title">
//               a force for activating cities and reenergizing cultures
//             </div>
//             <div className="separator"></div>
//           </div>

//           <div className="row clearfix">
//             {services.map((s, i) => (
//               <div
//                 className="services-block-two col-md-4 col-sm-6 col-xs-12"
//                 key={i}
//               >
//                 <div className="inner-box">
//                   <div className="icon-box">
//                     <img src={s.icon} alt="" />
//                   </div>
//                   <h3>
//                     <a href={s.href}>{s.title}</a>
//                   </h3>
//                   <div className="text">{s.text}</div>
                  
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


// src/components/ServicesSectionTwo.jsx
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css"; // make sure package is installed

export default function ServicesSectionTwo() {
  const bgStyle = { backgroundImage: "url('/images/background/1.jpg')" };

  const services = [
    {
      icon: "/images/page-img/Parking.png",
      title: "Parking",
      text:
        "Adequate parking facilities have been thoughtfully provided to ensure the utmost convenience for our residents, addressing their parking needs seamlessly.",
    },
    {
      icon: "/images/page-img/Free-Wifi.png",
      title: "Free Wifi",
      text:
        "In this fast-paced digital age, connectivity is key, and Shree Swami Samarth PG is committed to providing residents with a seamless online experience through free WiFi services.",
    },
    {
      icon: "/images/page-img/Refrigerator.png",
      title: "Refrigerator",
      text:
        "Each room is thoughtfully equipped with a refrigerator, adding a touch of convenience to residents' stays by providing a handy space for storing and preserving their essentials.",
    },
    {
      icon: "/images/page-img/Almirah.png",
      title: "Almirah",
      text:
        "In every room, residents benefit from the availability of spacious almirahs, ensuring organized and efficient storage solutions to enhance their living experience.",
    },
    {
      icon: "/images/page-img/Washroom.png",
      title: "Washroom",
      text:
        "Residents benefit from conveniently accessible and well-maintained washrooms, reflecting our commitment to ensuring their comfort and satisfaction with the overall living.",
    },
    {
      icon: "/images/page-img/CCTV-Camera.png",
      title: "CCTV Camera",
      text:
        "Prioritizing the safety of our residents, key areas are equipped with CCTV cameras, underscoring our commitment to maintaining a secure and protected living environment.",
    },
    // 🌟 New FontAwesome-based services
    {
      icon: "fa-solid fa-dumbbell",
      title: "Gym",
      text:
        "Stay fit and active with our well-equipped gym, offering modern exercise equipment and a motivating space for residents to maintain their health routines effortlessly.",
    },
    {
      icon: "fa-solid fa-futbol",
      title: "Turf",
      text:
        "Our recreational turf area provides residents with the perfect space to engage in outdoor sports, relax, and enjoy leisure activities within the premises.",
    },
    {
      icon: "fa-solid fa-table-tennis-paddle-ball",
      title: "Pool Table",
      text:
        "For those seeking indoor recreation, our pool table setup offers the perfect place to unwind and enjoy friendly matches with fellow residents.",
    },
    {
      icon: "fa-solid fa-basketball",
      title: "Sports Club",
      text:
        "Experience a vibrant sports culture with our dedicated sports club that promotes active living, teamwork, and regular physical engagement for all residents.",
    },
  ];

  return (
    <section className="services-section-two" style={bgStyle}>
      <div className="section-inner">
        <div className="auto-container">
          {/* Section Title */}
          <div className="sec-title light centered">
            <h2>Our Services</h2>
            <div className="sub-title">
              a force for activating cities and reenergizing cultures
            </div>
            <div className="separator"></div>
          </div>

          <div className="row clearfix">
            {services.map((s, i) => (
              <div
                className="services-block-two col-md-4 col-sm-6 col-xs-12"
                key={i}
              >
                <div className="inner-box">
                  <div className="icon-box">
                    {s.icon.startsWith("/") ? (
                      <img src={s.icon} alt={s.title} />
                    ) : (
                      <i className={`${s.icon} fa-3x`} style={{ color: "#fff" }}></i>
                    )}
                  </div>
                  <h3>{s.title}</h3>
                  <div className="text">{s.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
